module.exports = __webpack_public_path__ + "img/ic_settings_48px_99a0b4ff.9652397a.svg";